export enum CustomCharts {
	HeniNewsExclusive = 'heni-news-exclusive',
	Newsletter = 'heni-news-newsletter',
	LatestPodcasts = 'heni-news-latest-podcasts',
}
